import React from "react";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useNavigate } from "react-router-dom";

export default function LivePage2() {
  const navigate = useNavigate();

  return (
    <div className="live-video-page">
      <div className="live-wrapper">
        <video
          className="live-video"
          autoPlay
          loop
          playsInline
          src="/images/marija_live2.mp4"
        />

        <div className="live-header">
          <img
            src="images/marija_1.png"
            className="live-avatar"
            alt="profile"
          />
          <div className="live-user-info">
            <span className="live-username">marija_s</span>
          </div>

          <button
            className="leave-live-btn"
            onClick={() => navigate("/notifikacije3")}
          >
            Leave Live
          </button>
        </div>

        <div className="live-chat-box">
          <div className="chat-title">
            Chat <ArrowDropDownIcon />
          </div>

          <div className="chat-messages">
            <div className="chat-message">
              <div className="chat-avatar" />
              <div>
                <div className="chat-name">predrag_758</div>
                <div className="chat-text">Zravooo</div>
              </div>
              <span className="chat-time"></span>
            </div>

            <div className="chat-message">
              <div className="chat-avatar" />
              <div>
                <div className="chat-name">dzonii</div>
                <div className="chat-text">Tooo</div>
              </div>
              <span className="chat-time"></span>
            </div>
          </div>

          <input
            type="text"
            placeholder="Write something..."
            className="chat-input-lp"
          />
        </div>

        <div className="hearts-animated">
          <FavoriteIcon className="heart-float heart-float-1" />
          <FavoriteIcon className="heart-float heart-float-2" />
          <FavoriteIcon className="heart-float heart-float-3" />
          <FavoriteIcon className="heart-float heart-float-4" />
        </div>
      </div>
    </div>
  );
}
